var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.error404)?_c('div',{style:(_vm.computedStyle)},[_c('SideBarLevel1',{attrs:{"state":_vm.state}}),_c('SideBarLevel2')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }